import React, { useEffect, useState } from 'react';
import images from '../../helpers/images';
 
function FaqPage (){
    useEffect(() => {
        //Mounted
    }, []);

    return (
        <div>
            <div id="faq-banner-section" />

            <div id="faq-content-section" className='mt-5'>
                <div className="container">
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-lg-7 col-md-12">
                            <div className="faq-box">
                                <h1 className='mb-5'>Frequently Asked Questions - FAQS</h1>
                                <h2>Q: Will I get updates about my donation?</h2>
                                <p>Yes! We will provide updates 6 months after your donation. When applicable, we will invite you to visit the area and see the actual developments on the field.</p>

                                <hr />
                                
                                <h2>Q: What areas will benefit from this campaign?</h2>
                                <p>As of today, here are the areas (but are not limited to) that will benefit from the campaign: Marawi, Cotabato City, Zamboanga Del Norte, Pangasinan, Batangas, Camarines Norte, Bukidnon, Sultan Kudarat.</p>
                                
                                <hr />
                                
                                <h2>Q: Can I donate to more than one campaign?</h2>
                                <p>Yes! You can donate to all or any of your preferred campaigns, and we shall keep you updated about each campaign you donated to.</p>
                                
                                <hr />
                                
                                <h2>Q: Can I give an amount that is below the donation asked?</h2>
                                <p>Yes. The minimum donation amount for this campaign is P10,000. In this case, we will pool your donation with other donors’ donations to complete the required amount in support of a specific campaign.</p>
                                
                                <hr />
                                
                                <h2>Q: I wish to know more about the campaigns, is there someone that we can talk to?</h2>
                                <p>Yes, and you can get in touch with our donor engagement officer, Mr. LJ Galang. You may email him at leoverjulian_galang@wvi.org or give him a call/Viber at 09984758765. He will be happy to assist with your inquiries about our Level Up campaigns.</p>
                                
                                <hr />
                                
                                <h2>Q: Can I request a certificate of donation from this campaign?</h2>
                                <p>Yes. We can issue a certificate of donation upon request. You will have to provide your personal or business tax identification number so we can process the certificate. Please also note that a Certificate of Donation request is only applicable to self-employed individuals and private-sector business organizations.</p>
                                
                                <hr />
                            </div>
                        </div>
                        <div className="col-2" />
                    </div>
                </div>
            </div>


        </div>
    )
}
 
export default FaqPage;